import PropTypes from 'prop-types';
import React from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';

// eslint-disable-next-line react/prefer-stateless-function
export class WallpaperWrapper extends React.Component {
  render() {
    return (
      <TransitionGroup appear={true} component={null}>
        <CSSTransition
          key={this.props.creativeRandomKey}
          timeout={600}
          className="wallpaper__content"
          classNames={{
            appearDone: 'wallpaper__content--appear-done',
            enterDone: 'wallpaper__content--enter-done',
            exit: 'wallpaper__content--exit',
            exitActive: 'wallpaper__content--exit-active',
          }}
        >
          <div>{this.props.children}</div>
        </CSSTransition>
      </TransitionGroup>
    );
  }
}

WallpaperWrapper.propTypes = {
  children: PropTypes.node,
  creativeRandomKey: PropTypes.string,
};
